module.exports = __webpack_public_path__ + "static/img/nagraniaBackground.790fd597.jpg";